const statuses = {
	copyright: 'copyright',
	censored: 'censored',
	topspy: 'topspy',
	private: 'private'
};

const locale = {
	ru: {
		copyright: 'Авторский',
		censored: 'Цензура',
		topspy: 'Топ спай',
		private: 'Приватный'
	},
	en: {
		copyright: 'Copyright',
		censored: 'Censored',
		topspy: 'Top spy',
		private: 'Private'
	},
	uk: {
		copyright: 'Copyright',
		censored: 'Censored',
		topspy: 'Top spy',
		private: 'Private'
	},
	de: {
		copyright: 'Copyright',
		censored: 'Censored',
		topspy: 'Top spy',
		private: 'Private'
	},
	vi: {
		copyright: 'Copyright',
		censored: 'Censored',
		topspy: 'Top spy',
		private: 'Private'
	},
	th: {
		copyright: 'Copyright',
		censored: 'Censored',
		topspy: 'Top spy',
		private: 'Private'
	}
};

module.exports = {
	enum: statuses,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/offer-promo-labels.js